import React from 'react';
import { CalendarIcon, ArrowRightIcon } from 'lucide-react';
type ConsultCTAProps = {
  variant?: 'dark' | 'light';
};
export function ConsultCTA({
  variant = 'dark'
}: ConsultCTAProps) {
  const isDark = variant === 'dark';
  return <section className={`w-full py-14 md:py-20 px-4 ${isDark ? 'bg-jet-black' : 'bg-white'}`} data-id="element-53">
      <div className="max-w-4xl mx-auto text-center" data-id="element-54">
        <div className={`inline-flex items-center gap-2 px-4 py-2 rounded-full text-sm font-semibold mb-6 ${isDark ? 'bg-viridia-green/15 border border-viridia-green/30 text-viridia-green' : 'bg-viridia-green/10 text-deep-teal'}`} data-id="element-55">
          <CalendarIcon className="w-4 h-4" data-id="element-56" />
          Free 15-Minute Strategy Call
        </div>

        <h2 className={`text-2xl md:text-4xl font-extrabold mb-4 ${isDark ? 'text-white' : 'text-jet-black'}`} data-id="element-57">
          Not Sure Which Plan Fits?{' '}
          <span className="text-viridia-green" data-id="element-58">Let's Talk.</span>
        </h2>

        <p className={`text-lg md:text-xl mb-8 max-w-2xl mx-auto leading-relaxed ${isDark ? 'text-gray-400' : 'text-graphite-gray'}`} data-id="element-59">
          No pitch, no pressure. We'll look at your current lead sources, show
          you exactly how the system works, and help you figure out if it's a
          fit—in 15 minutes or less.
        </p>

        <a href="https://api.viridiaanalytics.com/widget/booking/hv5pIfS27zbJCMMGNnkJ" target="_blank" rel="noopener noreferrer" className="group inline-flex items-center gap-2 px-8 py-4 bg-viridia-green text-white text-lg font-bold rounded-lg hover:bg-deep-teal hover:scale-105 hover:shadow-xl hover:shadow-viridia-green/20 transition-all duration-200" data-id="element-60">
          Book a Free Strategy Call
          <ArrowRightIcon className="w-5 h-5 group-hover:translate-x-1 transition-transform" data-id="element-61" />
        </a>

        <p className={`text-sm mt-4 ${isDark ? 'text-gray-500' : 'text-gray-400'}`} data-id="element-62">
          No commitment required. We'll walk through your setup in 15 minutes.
        </p>
      </div>
    </section>;
}